// extracted by mini-css-extract-plugin
module.exports = {"container":"supply-set_container__3ljFk","description-item":"supply-set_description-item__3DO9g"};